import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                 from '../shared/shared.module';
import { VVGarageAddCustomerComponent } from './vv-garage.add-customer.component';
import { VVGarageService }              from './vv-garage.service';
import { VVGarageSettingsComponent }    from './vv-garage.settings.component';
import { VVGarageStates }               from './vv-garage.states';

@NgModule({
  declarations: [
    VVGarageAddCustomerComponent,
    VVGarageSettingsComponent
  ],
  entryComponents: [
    VVGarageAddCustomerComponent,
    VVGarageSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: VVGarageStates })
  ],
  providers: [
    VVGarageService
  ]
})
export class VVGarageModule {}
